import { ConfigTypeOverride } from '@cp/shared/config';
import { ConfigManager } from './manager';

export const createConfig = (runtimeConfig: Record<string, unknown> = {}) => {
  return new ConfigManager<ConfigTypeOverride>({
    ...runtimeConfig,
  } as ConfigTypeOverride);
};
